<template>
  <div id="pageRoot">

    <div id="clouds1" class="slideItem">
      <img class="pageElement" src="/pages/img/sordocas/svgClouds01.svg" />
    </div>
    <div id="clouds2" class="slideItem">
      <img class="pageElement" src="/pages/img/sordocas/svgClouds02.svg" />
    </div>
    <div id="bats" class="bouncingItem">
      <img class="pageElement" src="/pages/img/sordocas/svgCasBats.svg" />
    </div>
    <img
      id="castle"
      class="pageElement"
      src="/pages/img/sordocas/svgCastle.svg"
    />
    <div id="title" class="appearAnimationA">
      <img class="pageElement" src="/pages/img/sordocas/svgCas1Title.svg" />
    </div>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 30px;
  top: 48px;
}
#clouds1 {
  position: absolute;
  left: 65px;
  top: 48px;
  animation-duration: 6s;
  z-index: 1;
}
#clouds2 {
  position: absolute;
  left: 30px;
  top: 270px;
  z-index: 2;
}
#bats {
  position: absolute;
  left: 66px;
  top: 129px;
  z-index: 3;
}
#castle {
  position: absolute;
  left: 383px;
  top: 263px;
  z-index: 4;
}
#title {
  position: absolute;
  left: 98px;
  top: 204px;
  z-index: 5;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 1.mp4"],
    }
  }
}
</script>